import React, { Fragment } from 'react'
import './print.css'

export default ({ children }) => (
        <div className='no-print'>
            {children}
        </div>
    )